import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/vint50.png';

const Preloader = ({ onComplete }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(timer);
                    setTimeout(onComplete, 800);
                    return 100;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 150);

        return () => {
            clearInterval(timer);
        };
    }, [onComplete]);

    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'var(--bg-dark)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                color: 'var(--text-main)',
            }}
        >
            <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                style={{ textAlign: 'center', marginBottom: '40px' }}
            >
                {/* Logo */}
                <motion.div
                    animate={{
                        filter: ["drop-shadow(0 0 0px rgba(255, 255, 255, 0))", "drop-shadow(0 0 20px rgba(255, 255, 255, 0.2))", "drop-shadow(0 0 0px rgba(255, 255, 255, 0))"]
                    }}
                    transition={{ duration: 2, repeat: Infinity }}
                >
                    <img src={logo} alt="Vintage Dealership Logo" style={{ width: '150px', marginBottom: '30px', filter: 'brightness(1.1)' }} />
                </motion.div>

                <h1 style={{
                    color: 'var(--text-main)',
                    fontSize: '3rem',
                    fontWeight: 'bold',
                    letterSpacing: '4px',
                    margin: '0 0 15px 0',
                    fontFamily: 'var(--font-heading)',
                    textTransform: 'uppercase'
                }}>
                    Vintage Dealership
                </h1>
                <p style={{
                    color: 'var(--primary-accent)',
                    fontSize: '1.1rem',
                    letterSpacing: '2px',
                    fontFamily: 'var(--font-body)',
                    textTransform: 'uppercase'
                }}>
                    Excellence in Automotive Care
                </p>
            </motion.div>

            {/* Progress Bar Container */}
            <div style={{
                width: '300px',
                height: '2px',
                backgroundColor: 'var(--bg-surface)',
                borderRadius: '2px',
                overflow: 'hidden',
                position: 'relative',
                marginBottom: '15px'
            }}>
                <motion.div
                    style={{
                        height: '100%',
                        backgroundColor: 'var(--highlight-gold)',
                        width: `${progress}%`,
                        boxShadow: '0 0 10px var(--highlight-gold)'
                    }}
                />
            </div>

            <div style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.9rem',
                color: 'var(--text-muted)',
                letterSpacing: '1px'
            }}>
                {Math.round(progress)}%
            </div>

            <div style={{
                position: 'absolute',
                bottom: '30px',
                fontSize: '0.8rem',
                color: 'var(--text-muted)',
                fontFamily: 'var(--font-body)',
                letterSpacing: '1px'
            }}>
                Powered by <span style={{ color: 'var(--highlight-gold)', fontWeight: 'bold' }}>RoBo Technologies</span>
            </div>
        </motion.div>
    );
};

export default Preloader;
